import { useEffect } from 'react';
import appConfig from '@frontend/env';
import { useFetch } from '@frontend/fetch';

/**
 * Sets up the API base URL for the digital forms experience app
 */
export const useSetApiBaseUrl = () => {
  const { setBaseUrl } = useFetch();

  useEffect(() => {
    const baseUrl = appConfig.FORMS_XP_BACKEND_BASE_URL;
    if (baseUrl) {
      setBaseUrl(baseUrl);
    }
  }, [setBaseUrl]);
};
